const IubendaManager = (() => {

  const init = () => {
    // if (!document.getElementById('iubenda-custom-scripts')) {
    //   const iubendaScript = document.createElement('div')
    //   iubendaScript.id = 'iubenda-custom-scripts'
    //   iubendaScript.innerHTML = `
    //   <!--Iubenda banner cookie-->
    //   <script type="text/javascript">
    //   var _iub = _iub || [];
    //   _iub.csConfiguration = {"invalidateConsentWithoutLog":true,"cookiePolicyInOtherWindow":true,"reloadOnConsent":true,"askConsentAtCookiePolicyUpdate":true,"consentOnContinuedBrowsing":false,"perPurposeConsent":true,"purposes":"4,5","whitelabel":false,"lang":"it","siteId":1396154,"cookiePolicyId":70179472, "banner":{ "closeButtonRejects":true,"acceptButtonDisplay":true,"customizeButtonDisplay":true,"acceptButtonColor":"rgba(103, 177, 201, 1)","acceptButtonCaptionColor":"white","customizeButtonColor":"#c6c6c6","customizeButtonCaptionColor":"white","rejectButtonDisplay":true,"rejectButtonColor":"#c6c6c6","rejectButtonCaptionColor":"white","textColor":"black","backgroundColor":"white","content":"<div id=\"iubenda-cs-title\">Informativa</div><div id=\"iubenda-cs-paragraph\"><p class=\"iub-p\">\nQuesto sito utilizza cookies tecnici per il suo funzionamento e, previo tuo consenso, cookies di profilazione per offrire un servizio personalizzato. Puoi accettare tutti o alcuni cookies tramite i pulsanti sottostanti. Puoi rifiutarli cliccando sull’apposito pulsante o sulla ‘X’ in alto a destra. Per maggiori informazioni, consulta la nostra <a href=\"https://www.iubenda.com/privacy-policy/70179472/legal\" target=\"_blank\">Privacy Policy</a>.\n<a href=\"/privacy-policy/70179472/cookie-policy?an=no&s_ck=false&newmarkup=yes\" class=\"iubenda-cs-cookie-policy-lnk\">Cookie policy</a>.</p><br /></div>" }};
    //   </script>
    //   <script type="text/javascript" src="//cdn.iubenda.com/cs/iubenda_cs.js" charset="UTF-8" async></script>
    //   <script type="text/javascript"charset="UTF-8">
    //     console.log('Iubenda loaded async')
    //   </script>
    //   `

    //   document.body.appendChild(iubendaScript)
    // }
  }

  return {
    init,
  }
})()

export default IubendaManager
